export const environment = {
  production: false,
  apiUrl: 'https://api-stg.jeeran-realestate.com/api',
};
